export const typeToInputNameMappings = Object.freeze({
	commission: 'amount',
	participation: 'factor',
});
